import React, { Component } from 'react'
import { withTheme } from 'styled-components'
import { getFirstName, getDaysSinceWeighIn, LBS_PER_KG } from '../../../util'
import { Link } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Icon from '@material-ui/core/Icon'
import Loading from '../components/loading'
import AvatarButton from '../components/avn-button'

import FatLoss from '../../../../../../../images/change-goal-pictures/weight-loss-2020.png'
import Maintenance from '../../../../../../../images/change-goal-pictures/maintenance-2020.png'
import MuscleGain from '../../../../../../../images/change-goal-pictures/muscle-gain-2020.png'
import ReverseDieting from '../../../../../../../images/change-goal-pictures/reverse-2020.png'

import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import {GoalData, signLevels, signGradients,} from '../../../goal-level-data'
import styled from "styled-components";
import { modifyUser } from "../../../../../../../api";
import {UserCheckinWarning} from '../components/user-check-in-warning'
import CheckinFormPortal from '../components/check-in-2-4'

let sliderMax = 100
let sliderMin = 0

const TargetInput = styled.input`
  background: #dee6f7;
  border: none;
  border-radius: 100px;
  color: #516375;
  font-size: 1.25rem;
  height: 56px;
  min-width: 200px;
  padding: 0px 28px;
  @media(max-width: 900px) {
    font-size: 1rem;
    height: 47px;
    min-width: 150px
    padding: 0px 18px;
  }
`;

const UnitButton = styled.button`
  background: none;
  border: ${(props) => (props.selected ? "4px solid #07c43f" : "4px solid #FFF")};
  border-radius: 100px;
  color: #FFF;
  font-size: 1rem;
  font-weight: 500;
  height: 56px;
  padding: 15px 15px;
  margin-left: 15px;
  text-transform: none;
  white-space: nowrap;

  @media (max-width: 900px) {
    font-size: .875rem;
    font-weight: 400;
    height: 38px;
    padding: 6px 16px;
    margin: 16px 8px 16px 8px;
  }
`;

const GoalLevelSlider = withStyles({
  root: {
    color: '#06cb40',
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#dae3f1',
    border: '6px solid currentColor',
    marginTop: -13,
    marginLeft: -13,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: '#b7c1d6',
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const CalorieSlider = withStyles({
  root: {
    color: '#FFF',
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#dae3f1',
    border: '6px solid currentColor',
    marginTop: -13,
    marginLeft: -13,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: '#b7c1d6',
    height: 8,
    borderRadius: 4,
  },
})(Slider);

class ChangeGoalSettings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disableSubmit: true,
      isSubmitting: false,
      currentGoal: this.props.goal,
      show5DayWeighInExplanation: false,
      showWeighInExplanation: false,
      showEstimatedWeightExplanation: false,
      showGoalChangeWarning: false,
      currentModifier: this.props.oldModifier,
      calorieBoost: (this.props.calorieBoost === 1) ? true : false,
      showCalorieBoost: false,
      showEstimatedWeight: false,
      max: 5,
      min: 1,
      metric: '',
      isLoading: true,
      showVacationModal: false,
      calorieBoostAmount: null,
      goalLevelSliderVal: this.props.oldSliderVal,
      reverseMoreCalories: '',
      calorieSlider: 5,
      recenter: false,
      target_weight: '',
      unitType: 'lbs',
      showUserCheckinWarning: false,
      showCheckinFormPortal: false,
    }
  }

  componentDidMount() {
    const daysSinceWeighIn = getDaysSinceWeighIn(this.props.lastWeighInDate)
    const calorieBoost = (this.props.calorieBoost === 1) ? true : false
    const showCalorieBoost = (this.props.goal === 'REVERSE DIETING' && daysSinceWeighIn < 5) ? true : false
    const showVacationModal = (this.props.vacationMode !== 0 && !this.props.resumeGoalChangeMode) ? true : false

    this.weight = this.checkMetric(this.props.useMetric, this.props.targetWeight)

    const min = this.setMinRange(this.weight)
    const max = this.setMaxRange(this.props.useMetric === 1, this.weight)
    const loadUnit = Number(this.props.useMetric) === 1 ? 'kg' : 'lbs'

    this.setState({
      disableSubmit: true,
      currentGoal: this.props.goal,
      currentModifier: this.props.oldModifier,
      calorieBoost: calorieBoost,
      showCalorieBoost: showCalorieBoost,
      max: max,
      min: min,
      showVacationModal: showVacationModal,
      goalLevelSliderVal: this.props.oldSliderVal,
      unitType: loadUnit,
      target_weight: this.weight,
    })
  }

  componentWillUnmount() {
    // this.props.enableResumeGoalChangeMode(false)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(this.props.goal !== nextProps.goal) {
      const daysSinceWeighIn = getDaysSinceWeighIn(nextProps.lastWeighInDate)
      const calorieBoost = (nextProps.calorieBoost === 1) ? true : false
      const showCalorieBoost = (daysSinceWeighIn < 5 && (this.props.goal === 'REVERSE DIETING' || nextProps.goal === 'REVERSE DIETING')) ? true : false
      const showVacationModal = (nextProps.vacationMode !== 0 && !nextProps.resumeGoalChangeMode) ? true : false

      this.weight = this.checkMetric(nextProps.useMetric, nextProps.targetWeight)

      const min = this.setMinRange(this.weight)
      const max = this.setMaxRange(nextProps.useMetric === 1, this.weight)
      const loadUnit = Number(this.props.useMetric) === 1 ? 'kg' : 'lbs'

      this.setState({
        disableSubmit: true,
        currentGoal: nextProps.goal,
        currentModifier: nextProps.oldModifier,
        calorieBoost: calorieBoost,
        showCalorieBoost: showCalorieBoost,
        max: max,
        min: min,
        showVacationModal: showVacationModal,
        goalLevelSliderVal: nextProps.oldSliderVal,
        unitType: loadUnit,
      })
    } else if(this.props.targetWeight !== nextProps.targetWeight) {
      this.weight = this.checkMetric(nextProps.useMetric, nextProps.targetWeight)
    }
  }

  handleCalorieBoostSliderChange = (e, value) => {
    this.setState({calorieBoostAmount: value, disableSubmit: false})
  }

  getGoalLevelInfo = () => {
    let goalLevelInfo = {
      calorie_restricted: (this.state.currentGoal === 'REVERSE DIETING' && this.props.goal !== 'MUSCLE GAIN' && this.state.calorieBoost) ? 1 : 0
    }

    if(this.state.currentGoal === 'MAINTENANCE') {
      goalLevelInfo['target_weight'] = (this.props.goal !== 'MAINTENANCE' || this.state.recenter) ? this.props.weight : this.props.targetWeight
      goalLevelInfo['goal_weight_delta'] = Math.round((this.props.useMetric === 1 ? this.state.currentModifier : (this.state.currentModifier / 2.204622)) * 1000000) / 1000000
    } else if (this.state.currentGoal) {
      const range = sliderMax - sliderMin
      const levelData = GoalData.get(this.state.currentGoal)
      const currentWeightKg = Number(this.props.weight)

      const newGoalLevels = levelData.resultValue((this.state.goalLevelSliderVal / range), {
        weight: currentWeightKg,
        goalMinWeeklyCalIncrease: this.props.goalMinWeeklyCalIncrease,
        gender: this.props.gender,
      })

      if(this.state.currentGoal === 'REVERSE DIETING') {
        goalLevelInfo['goal_min_weekly_calorie_increase'] = newGoalLevels
      }
      if(this.state.currentGoal === 'REVERSE DIETING' && this.props.goal !== 'MUSCLE GAIN') {
        goalLevelInfo['calorie_boost'] = this.state.calorieBoost ? ((this.props.goal === 'FAT LOSS' && this.state.calorieBoostAmount !== null) ? this.state.calorieBoostAmount : 10) : 0
      }

      if(this.state.currentGoal === "FAT LOSS" || this.state.currentGoal === "MUSCLE GAIN") {
        const targetWeightKg = this.state.unitType === 'lbs' ? Number(this.state.target_weight) / 2.204622 : Number(this.state.target_weight)
        goalLevelInfo['goal_weight_delta'] = newGoalLevels
        goalLevelInfo['target_weight'] = targetWeightKg
      }
    }

    return goalLevelInfo
  }

  handleSubmit = () => {
    const daysAfterLastCheckIn = getDaysSinceWeighIn(this.props.lastWeighInDate)
    const targetWeightKg = this.state.unitType === 'lbs' ? Number(this.state.target_weight) / 2.204622 : Number(this.state.target_weight)
    const currentWeightKg = Number(this.props.weight)

    if (!this.state.target_weight && (this.state.currentGoal === 'FAT LOSS' || this.state.currentGoal === 'MUSCLE GAIN')) {
      this.props.openFeedback('Please enter a target weight', true)
      return
    } else if (!this.validateTargetWeight(targetWeightKg, currentWeightKg, this.state.currentGoal)) {
      return
    }

    if (daysAfterLastCheckIn >= 1 && daysAfterLastCheckIn < 5) {
      this.setState({showCheckinFormPortal: true})
      return
    } else if (daysAfterLastCheckIn >= 5) {
      this.setState({showUserCheckinWarning: true})
      return
    }

    this.setState({ isSubmitting: true })

    let req = {
      goal: this.state.currentGoal,
      ...this.getGoalLevelInfo()
    }

    modifyUser(this.props.userId, this.props.portalId, req).then(() => {
      this.setState({ isSubmitting: false, recenter: false })
      this.props.loadPortalAccount();
      this.props.openFeedback('Goal change successful!', false)
      this.props.closeGoalModal()
    }).catch((res) => {
      this.setState({ isSubmitting: false })
      this.props.openFeedback('Failed to change goal', true)
    })
  }

  handleFatLossSubmit = () => {
    const daysSinceWeighIn = getDaysSinceWeighIn(this.props.lastWeighInDate)
    if(daysSinceWeighIn !== 0) {
      if(daysSinceWeighIn >= 5 && !this.props.resumeGoalChangeMode) {
        this.setState({ show5DayWeighInExplanation: true, showGoalChangeWarning: false })
      } else {
        this.setState({ showWeighInExplanation: true, showGoalChangeWarning: false })
      }
      return
    }

    const req = {
      goal: this.state.currentGoal,
      ...this.getGoalLevelInfo()
    }

    if(this.props.resumeGoalChangeMode)
      req['vacation_mode'] = 0

    modifyUser(this.props.userId, this.props.portalId, req).then(() => {
      this.props.loadPortalAccount();
      this.props.openFeedback('Goal change successful!', false);
      this.props.closeGoalModal();
    }).catch(() => {
      this.props.openFeedback('Failed to change goal', true)
    })
  }

  handleClickGoal = (e) => {
    if(e.target.value === 'MAINTENANCE') {
      if(this.props.goal === 'MAINTENANCE') {
        this.setState({ currentGoal: e.target.value, currentModifier: this.props.oldModifier, disableSubmit: true })
      } else if(this.props.goal === 'REVERSE DIETING') {
        this.setState({ currentGoal: e.target.value, currentModifier: this.state.max, disableSubmit: false })
      } else {
        this.setState({ currentGoal: e.target.value, currentModifier: this.props.oldModifier, disableSubmit: false })
      }
    } else if(e.target.value === this.props.goal) {
      this.setState({ currentGoal: e.target.value, goalLevelSliderVal: this.props.oldSliderVal, disableSubmit: true })
    } else {
      this.setState({ currentGoal: e.target.value, goalLevelSliderVal: this.props.oldSliderVal, disableSubmit: false })
    }
  }

  getGoalLevel = () => {
    if(!this.props.goal) // NOTE: Required when getUserFetch is not completed
      return

    if(this.props.goal === 'MAINTENANCE') {
      if(this.props.useMetric === 1) {
        return (this.props.targetWeight - this.props.goal_weight_delta).toFixed(1) + ' - ' + (this.props.targetWeight + this.props.goal_weight_delta).toFixed(1) + ' KG'
      } else {
        return ((this.props.targetWeight - this.props.goal_weight_delta) * 2.204622).toFixed(1) + ' - ' + ((this.props.targetWeight + this.props.goal_weight_delta) * 2.204622).toFixed(1) + ' LBS'
      }
    } else if(this.props.goal === 'REVERSE DIETING') {
      return this.props.goal_min_weekly_calorie_increase + ' - ' + (this.props.goal_min_weekly_calorie_increase + 15) + ' CAL/WEEK'
    } else if(this.props.useMetric === 1) {
      return this.props.goal_weight_delta.toFixed(2) + ' KG/WEEK'
    } else {
      return (this.props.goal_weight_delta * 2.204622).toFixed(2) + ' LBS/WEEK'
    }
  }

  validateTargetWeight = (targetWeightKg, weightKg, goal) => {
    const targetWeightKgRounded = Math.round(targetWeightKg * 100) / 100;
    const weightRounded = Math.round(weightKg * 100) / 100;

    if (goal === 'MUSCLE GAIN' && targetWeightKgRounded <= weightRounded) {
      this.props.openFeedback('Choose a weight higher than your current weight', true)
      return false;
    } else if (goal === 'FAT LOSS' && targetWeightKgRounded >= weightRounded) {
      this.props.openFeedback('Choose a weight lower than your current weight', true)
      return false;
    }
    return true;
  };

  handleSlider = (e) => {
    this.setState({ currentModifier: Math.round(e.target.value * 10) / 10, disableSubmit: false })
  }

  getProgress = (currentModifier) => {
    let width = 1 * (currentModifier) + 30
    return width.toString()+'%'
  }

  setMaxRange = (isUsingMetricUnits, weight) => {
    let max = 3.5
    const imperialWeight = (isUsingMetricUnits) ? (weight * LBS_PER_KG) : weight

    if(imperialWeight > 125 && imperialWeight <= 175) {
      max = 4
    } else if(imperialWeight > 175 && imperialWeight <= 225) {
      max = 4.5
    } else if(imperialWeight > 225 && imperialWeight <= 275) {
      max = 5
    } else if(imperialWeight > 275) {
      max = 5.5
    }

    return (isUsingMetricUnits) ? (max / LBS_PER_KG) : max
  }

  setMinRange = (bodyWeight) => {
    const bodyWeightGreater = ((bodyWeight / 100) > 1)
    const min = (bodyWeightGreater) ? (bodyWeight / 100) : 1
    return min
  }

  getMin = (rangeCenter) => {
    return (rangeCenter - this.state.currentModifier).toFixed(1)
  }

  getMax = (rangeCenter) => {
    return (rangeCenter + this.state.currentModifier).toFixed(1)
  }

  checkMetric = (useMetric, weight) => {
    if(Number(useMetric) === 1)
      return weight
    else
      return Math.round((weight * LBS_PER_KG) * 100) / 100
  }

  handleCalorieBoostChange = (val) => {
    this.setState({
      calorieBoost: (Number(val) === 0) ? false : true,
    })
  }

  shouldShowChangeWarning = (currGoal, newGoal) => {
    return false
  }

  handleGoalSlider = (val) => {
    this.setState({ goalLevelSliderVal: Number(val), disableSubmit: false })
  }

  renderGoalLevel = (goal) => {
    if (!goal) return
    if (goal === 'MAINTENANCE') {
      const rangeCenter = this.checkMetric(this.props.useMetric, (this.props.goal !== 'MAINTENANCE' || this.state.recenter) ? this.props.weight : this.props.targetWeight)
      return (
        <div className="goal-level-container">
          <p className="registration-maintenance-description" >{this.props.theme.goal["MAINTENANCE"]} keeps your weight within a specific range. Use the slider below to select the range that's right for you. If you check in above or below this, your target macros will be adjusted accordingly.</p>
          <div className='maintenance-target-container'>
            <div className='maintenance-target'>
              <p>Min</p>
              <h3>{this.getMin(rangeCenter)}<span>{(Number(this.props.useMetric) === 1) ? 'KG' : 'LBS'}</span></h3>
            </div>
            <div className='maintenance-target'>
              <p>Target</p>
              <h3>{Number(rangeCenter).toFixed(1)}<span>{(Number(this.props.useMetric) === 1) ? 'KG' : 'LBS'}</span></h3>
            </div>
            <div className='maintenance-target'>
              <p>Max</p>
              <h3>{this.getMax(rangeCenter)}<span>{(Number(this.props.useMetric) === 1) ? 'KG' : 'LBS'}</span></h3>
            </div>
          </div>
          <input className="avn-slider" id='maintenance-slider' type="range" min={this.state.min} max={this.state.max} step={0.1} name="currentModifier" value={this.state.currentModifier} onChange={this.handleSlider} />
          {goal === this.props.goal && this.props.weight !== this.props.targetWeight &&
            <div className='goal-question-container'>
              <h3>Do you want to recenter your maintenance range?</h3>
              <div className='reverse-buttons-container'>
                <button className='reverse-calorie-button' onClick={() => this.setState({disableSubmit: false, recenter: false})} style={(!this.state.recenter) ? {border: '3px solid #0ab23b', color: '#0ab23b'} : {border: '3px solid #ffffff', color: '#FFF'}}>No</button>
                <button className='reverse-calorie-button' onClick={() => this.setState({disableSubmit: false, recenter: true})} style={(this.state.recenter) ? {border: '3px solid #0ab23b', color: '#0ab23b'} : {border: '3px solid #ffffff', color: '#FFF'}}>Yes</button>
              </div>
            </div>
          }
        </div>
      )
    } else {
      // handle Fat Loss, Muscle Gain, and Reverse
      const initialIndex = this.state.goalLevelSliderVal
      const range = sliderMax - sliderMin
      const levelData = GoalData.get(goal)
      const currentWeightKg = Number(this.props.weight);

      const signIndex = levelData.signIndex(initialIndex, range)
      const signGradient = signGradients[signIndex];
      const signText = levelData.signText + signLevels[signIndex]
      const centralText = levelData.centralText((this.state.goalLevelSliderVal / range), {
        weight: currentWeightKg, 
        gender: this.props.gender,
        useMetricUnits: Number(this.props.useMetric)
      })

      switch(goal) {
        case 'FAT LOSS': return (
          <>
            <div className="goal-level-container">
              <h3>{levelData.title}</h3>
              <div className="goal-estimations">
                <p>{levelData.weightText}</p>
                <p><span>{centralText}</span>/week</p>
                <div className="goal-level-risk" style={{background: `linear-gradient(-90deg, ${signGradient[0]}, ${signGradient[1]})`}}>
                  <p>{signText}</p>
                </div>
              </div>
            </div>
            <GoalLevelSlider 
              min={sliderMin}
              max={sliderMax}
              step={1}
              value={this.state.goalLevelSliderVal}
              onChange={(e,val) => this.handleGoalSlider(val)}
              valueLabelDisplay='off'
              aria-label='goal-slider'
            />
            <div className='goal-question-container'>
              <h3>What is your target weight?</h3>
              <div className="goal-question-options">
                <TargetInput type="number" min="70" max="999" name="target_weight" placeholder="Target Weight" value={this.state.target_weight} onChange={(e) => this.setState({target_weight: e.target.value})} />
                <div>
                  <UnitButton selected={this.state.unitType === 'lbs'} onClick={(e) => {this.setState({unitType: 'lbs'});}}>
                    Pounds
                  </UnitButton>
                  <UnitButton selected={this.state.unitType === 'kg'} onClick={(e) => {this.setState({unitType: 'kg'});}}>
                    Kilograms
                  </UnitButton>
                </div>
              </div>
            </div>
          </>
        )
        case 'MUSCLE GAIN': return (
          <>
            <div className="goal-level-container">
              <h3>{levelData.title}</h3>
              <div className="goal-estimations">
                <p>{levelData.weightText}</p>
                <p><span>{centralText}</span>/week</p>
                <div className="goal-level-risk" style={{background: `linear-gradient(-90deg, ${signGradient[0]}, ${signGradient[1]})`}}>
                  <p>{signText}</p>
                </div>
              </div>
            </div>
            <GoalLevelSlider 
              min={0}
              max={100}
              step={1}
              value={this.state.goalLevelSliderVal}
              onChange={(e,val) => this.handleGoalSlider(val)}
              valueLabelDisplay='off'
              aria-label='highlow-slider'
            />
            <div className='goal-question-container'>
              <h3>What is your target weight?</h3>
              <div className="goal-question-options">
                <TargetInput type="number" min="70" max="999" name="target_weight" placeholder="Target Weight" value={this.state.target_weight} onChange={(e) => this.setState({target_weight: e.target.value})} />
                <div>
                  <UnitButton selected={this.state.unitType === 'lbs'} onClick={(e) => {this.setState({unitType: 'lbs'});}}>
                    Pounds
                  </UnitButton>
                  <UnitButton selected={this.state.unitType === 'kg'} onClick={(e) => {this.setState({unitType: 'kg'});}}>
                    Kilograms
                  </UnitButton>
                </div>
              </div>
            </div>
          </>
        )
        case 'REVERSE DIETING': {
          const calorieBoostAmount = this.state.calorieBoostAmount === null ? 10 : this.state.calorieBoostAmount
          
          return (
            <>
              <div className="goal-level-container">
                <h3>{levelData.title}</h3>
                <div className="goal-estimations">
                  <p>{levelData.weightText}</p>
                  <p><span>{centralText}</span>/week</p>
                  <div className="goal-level-risk" style={{background: `linear-gradient(-90deg, ${signGradient[0]}, ${signGradient[1]})`}}>
                    <p>{signText}</p>
                  </div>
                </div>
              </div>
              <GoalLevelSlider 
                min={0}
                max={100}
                step={1}
                value={this.state.goalLevelSliderVal}
                onChange={(e,val) => this.handleGoalSlider(val)}
                valueLabelDisplay='off'
                aria-label='highlow-slider'
              />
              {(((this.state.showCalorieBoost || this.state.calorieBoost === 1 || this.props.goal !== 'REVERSE DIETING')) && this.props.goal !== 'MUSCLE GAIN') ?
              <>
                <div className='goal-question-container'>
                  {this.props.theme.name === "AVATAR" ? 
                    <h3>Want more calories to start your reverse diet?</h3>
                  :
                    <h3>Want more calories to start Transition Phase?</h3>
                  } 
                  <div className='reverse-buttons-container'>
                    <button className='reverse-calorie-button' onClick={() => this.handleCalorieBoostChange(0)} style={(!this.state.calorieBoost) ? {border: '3px solid #0ab23b', color: '#0ab23b'} : {border: '3px solid #ffffff', color: '#FFF'}}>No</button>
                    <button className='reverse-calorie-button' onClick={() => this.handleCalorieBoostChange(1)} style={(this.state.calorieBoost) ? {border: '3px solid #0ab23b', color: '#0ab23b'} : {border: '3px solid #ffffff', color: '#FFF'}}>Yes</button>
                  </div>
                </div>

                <div className='select-goal-level-reverse-question'>
                  {(this.state.calorieBoost && this.props.goal === 'FAT LOSS') ?
                    <div style={{ padding: '12px 0' }}>
                      <p>Please use the slider below to select a calorie boost from 5% to 20%.</p>
                      <p>Selected calorie boost: { calorieBoostAmount }%</p>
                      <div style={{ padding: '12px 0' }}>
                        <CalorieSlider
                          value={calorieBoostAmount}
                          onChange={this.handleCalorieBoostSliderChange}
                          min={5}
                          max={20}
                          step={1}
                        />
                      </div>
                    </div>
                    :
                    null}
                </div>
              </>
              :
              null}
            </>
          )
        }
        default: return null
      }
    }
  }

  render() {
    const disableSubmit = (this.state.disableSubmit || (this.state.currentGoal === this.props.goal && (this.state.currentGoal === 'MAINTENANCE' ? this.state.currentModifier === this.props.oldModifier && !this.state.recenter : this.state.goalLevelSliderVal === this.props.oldSliderVal)))

    const isPaused = this.props.vacationMode && !this.props.vacationModeInfo?.practice_mode;
    const isPractice = this.props.vacationMode && this.props.vacationModeInfo?.practice_mode;
    const vacationText = isPaused ? "Pause" : isPractice ? "Practice" : "Vacation";

    return (
      // <div className={(this.props.vacationMode === 0 || this.props.resumeGoalChangeMode) ? 'change-goal-active' : 'change-goal-inactive'}>
      <div className="change-goal-active">
        <div style={{width: '100%'}}>
          <div className='avn-widget' style={{borderRadius: 0, padding: 0}}>
            <div className='change-goal-top-section'>
              <div className='goal-setting-header'>
                <h1 className='select-goal-header'>GOAL SETTING</h1>
                <p className='select-goal-header-subtext'>See your current goal and goal level</p>
                <p className='select-goal-header-subtext-goal'> {this.props.goal}</p>
              </div>
              <div className='goal-setting-status'>
                <p>{this.props.goal} {this.getGoalLevel()}</p>
              </div>
            </div>
            <div className='select-goal-and-level'>
              <div className="select-goal-container">
                <button className={this.state.currentGoal === 'FAT LOSS' ? 'select-goal-pair-active' : 'select-goal-pair-option'} name='currentGoal' value='FAT LOSS' onClick={this.handleClickGoal}>
                  <Loading size={50} className='loading' isLoading={this.props.isLoading}>
                    <h2>{this.props.theme.goal["FAT LOSS"]}</h2>
                    <img className='select-goal-icon' src={FatLoss} alt='fat-loss'/>
                    <div className={this.state.currentGoal === 'FAT LOSS' ? 'select-goal-option-active' : 'select-goal-option'}>
                      <p>{(this.state.currentGoal === 'FAT LOSS') ? <Icon className="material-icons" >check</Icon> : 'SELECT GOAL'}</p>
                    </div>
                  </Loading>
                </button>
                <button className={this.state.currentGoal === 'MUSCLE GAIN' ? 'select-goal-pair-active' : 'select-goal-pair-option'} name='currentGoal' value='MUSCLE GAIN' onClick={this.handleClickGoal}>
                  <Loading size={50} className='loading' isLoading={this.props.isLoading}>
                    <h2>{this.props.theme.goal["MUSCLE GAIN"]}</h2>
                    <img className='select-goal-icon' src={MuscleGain} alt='muscle'/>
                    <div className={this.state.currentGoal === 'MUSCLE GAIN' ? 'select-goal-option-active' : 'select-goal-option'}>
                      <p>{(this.state.currentGoal === 'MUSCLE GAIN') ? <Icon className="material-icons">check</Icon> : 'SELECT GOAL'}</p>
                    </div>
                  </Loading>
                </button>
                <button className={this.state.currentGoal === 'REVERSE DIETING' ? 'select-goal-pair-active' : 'select-goal-pair-option'} name='currentGoal' value='REVERSE DIETING' onClick={this.handleClickGoal}>
                  <Loading size={50} className='loading' isLoading={this.props.isLoading}>
                    <h2>{this.props.theme.goal["REVERSE DIETING"]}</h2>
                    <img className='select-goal-icon' src={ReverseDieting} alt='reverse'/>
                    <div className={this.state.currentGoal === 'REVERSE DIETING' ? 'select-goal-option-active' : 'select-goal-option'}>
                      <p>{(this.state.currentGoal === 'REVERSE DIETING') ? <Icon className="material-icons">check</Icon> : 'SELECT GOAL'}</p>
                    </div>
                  </Loading>
                </button>
                <button className={this.state.currentGoal === 'MAINTENANCE' ? 'select-goal-pair-active' : 'select-goal-pair-option'} name='currentGoal' value='MAINTENANCE' onClick={this.handleClickGoal}>
                  <Loading size={50} className='loading' isLoading={this.props.isLoading}>
                    <h2>{this.props.theme.goal["MAINTENANCE"]}</h2>
                    <img className='select-goal-icon' src={Maintenance} alt='maintenance'/>
                    <div className={this.state.currentGoal === 'MAINTENANCE' ? 'select-goal-option-active' : 'select-goal-option'}>
                      <p>{(this.state.currentGoal === 'MAINTENANCE') ? <Icon className="material-icons">check</Icon> : 'SELECT GOAL'}</p>
                    </div>
                  </Loading>
                </button>
              </div>
              <div className='select-goal-level-container'>
                {/* {(this.state.currentGoal === 'MAINTENANCE' || this.state.currentGoal === 'MUSCLE GAIN') && this.props.goal === 'FAT LOSS' &&
                 <p style={{paddingBottom: '10px', textAlign: 'center', fontWeight: 'bold'}}>Please make sure your activity level under <Link to="/dashboard/preferences">preferences</Link> reflects your expected activity level under the {this.state.currentGoal === 'MAINTENANCE' ? 'Maintenance' : 'Muscle Gain'} goal.</p>
                } */}
                {this.renderGoalLevel(this.state.currentGoal)}
                <div className='save-goal-button-container'>
                  <AvatarButton
                    className={'save-goal-button'}
                    style={disableSubmit ? {background: '#153e21', margin: '25px'}:{background: '#37ca6240', margin: '25px'}}
                    message='UPDATE GOAL'
                    onClick={this.handleSubmit}
                    isLoading={this.state.isSubmitting}
                    disabled={disableSubmit}
                  />
                </div>
              </div>
            </div>
          </div>

          <Dialog open={this.state.show5DayWeighInExplanation} onClose={() => { this.setState({ show5DayWeighInExplanation: false }); this.props.showModal('showWeighInModal', true)}}>
            <DialogContent className='avn-modal-content-container'>
              <p>{getFirstName(this.props.fullname)}, since you last weighed in {getDaysSinceWeighIn(this.props.lastWeighInDate)} days ago, you'll need to check in before selecting a new goal.</p>
            </DialogContent>
            <DialogActions className='avn-modal-actions-container'>
              <button className='avn-action-button' onClick={() => { this.setState({ show5DayWeighInExplanation: false }); this.props.showModal('showWeighInModal', true)}}>OK</button>
            </DialogActions>
          </Dialog>

          <Dialog open={this.state.showWeighInExplanation} onClose={() => { this.setState({ showWeighInExplanation: false }); this.props.showModal('showGoalWeighInModal', true)}}>
            <DialogContent className='avn-modal-content-container'>
              <p>{getFirstName(this.props.fullname)}, since you last weighed in {getDaysSinceWeighIn(this.props.lastWeighInDate)} days ago, you'll need to check in now. Note that your goal change for today will be discarded if you don't complete the check-in.</p>
            </DialogContent>
            <DialogActions className='avn-modal-actions-container'>
              <button className='avn-action-button' onClick={() => { this.setState({ showWeighInExplanation: false }); this.props.showModal('showGoalWeighInModal', true)}}>OK</button>
            </DialogActions>
          </Dialog>

          <Dialog open={this.state.showEstimatedWeightExplanation} onClose={() => { this.setState({ showEstimatedWeightExplanation: false }); this.props.showModal('showGoalWeighInModal', true)}}>
            <DialogContent className='avn-modal-content-container'>
              <p>When you weighed in today you believed that your menstrual cycle may have been artificially increasing your weight. To give the system a new starting weight for your goal, you will need to enter an estimated weight, which is your last known weight prior to being affected by your menstrual cycle.</p>
            </DialogContent>
            <DialogActions className='avn-modal-actions-container'>
              <button className='avn-action-button' onClick={() => { this.setState({ showEstimatedWeightExplanation: false }); this.props.showModal('showGoalWeighInModal', true)}}>OK</button>
            </DialogActions>
          </Dialog>

          <Dialog open={this.state.showGoalChangeWarning} onClose={() => { this.setState({ showGoalChangeWarning: false }); this.props.showModal('showGoalChangeWarning', true)}}>
            <DialogContent className='avn-modal-content-container'>
              <div className='goal-change-warning-container'>
                <p>Hey {getFirstName(this.props.fullname)}, to give your body time to adapt to your new, higher food intake, Avatar recommends that you change your goal to maintenance and stay on it for <span>at least the same length of time you spent reverse dieting</span> before switching to fat loss. Cutting calories too soon can compromise the progress you've made while reversing.</p>
              </div>
            </DialogContent>
            <DialogActions className='avn-modal-actions-three-button-container'>
              <div className='goal-warning-btn-group'>
                <AvatarButton className='avn-action-button'
                  message='SELECT FAT LOSS'
                  onClick={this.handleFatLossSubmit}
                  isLoading={this.props.isLoading}
                />
                <AvatarButton className='avn-action-button'
                  message='SELECT MAINTENANCE'
                  onClick={() => { this.setState({ showGoalChangeWarning: false, currentGoal: 'MAINTENANCE', currentModifier: this.state.max })}}
                  isLoading={this.props.isLoading}
                />
              </div>
            </DialogActions>
            <DialogActions className='avn-modal-actions-container' style={{ border: 'none'}}>
              <AvatarButton className='avn-action-warning-button-negative'
                message='CLOSE'
                onClick={() => { this.setState({ showGoalChangeWarning: false })}}
                isLoading={this.props.isLoading}
              />
            </DialogActions>
          </Dialog>

          {/* <AddWeighInModal goalChangeRequested={1} activityLevelChangeRequested={0} />
          <AddGoalWeighInModal goal={this.state.currentGoal} goalLevelInfo={this.getGoalLevelInfo()} /> */}

          <Dialog open={this.state.showVacationModal} onClose={() => this.setState({showVacationModal: false})}>
            <DialogContent className='avn-modal-content-container'>
              <p>{vacationText} mode</p>
              <p>To exit {vacationText} mode, please change the client's advanced settings.</p>
            </DialogContent>
            <DialogActions className='avn-modal-actions-container'>
              <Link to="/dashboard/preferences"><button className='avn-action-button' onClick={() => this.setState({showVacationModal: false})}>OK</button></Link>
            </DialogActions>
          </Dialog>

          <UserCheckinWarning
            open={this.state.showUserCheckinWarning}
            onClose={() => this.setState({showUserCheckinWarning: false})}
            daysAfterLastCheckIn={this.props.daysAfterLastCheckIn}
          />

          <CheckinFormPortal
            goalCheckin
            goal={this.state.currentGoal}
            goalLevelInfo={this.getGoalLevelInfo()}
            closeGoalModal={this.props.closeGoalModal}
            open={this.state.showCheckinFormPortal}
            onClose={() => this.setState({showCheckinFormPortal: false})} 
            openFeedback={this.props.openFeedback}
            userId={this.props.userId}
            portalId={this.props.portalId}
            loadPortalAccount={this.props.loadPortalAccount}
            weightString={this.props.weightString}
            previousWeight={this.props.previousWeight}
            previousBodyfat={this.props.previousBodyfat}
            useMetricUnits={this.props.useMetricUnits}
            daysAfterLastCheckIn={this.props.daysAfterLastCheckIn}
            gender={this.props.gender}
          />
        </div>
      </div>
    )
  }
}

// function mapStateToProps(state) {
//   let oldSliderVal = 0
//   let targetWeight = state.user.weight
//   let oldModifier = 3.4
//   if(state.user.goal === 'REVERSE DIETING') {
//     oldSliderVal = Math.round((state.user.goal_min_weekly_calorie_increase - (state.user.gender === 'MALE' ? 35 : 30)) * 100 / 30)
//   } else if (state.user.goal === 'FAT LOSS') {
//     if(state.user.weight) {
//       let fatLossRatio = state.user.goal_weight_delta / state.user.weight
//       if (fatLossRatio < 0.004) {
//         fatLossRatio = 0.004
//       } else if (fatLossRatio > 0.012) {
//         fatLossRatio = 0.012
//       }
//       oldSliderVal = Math.round((fatLossRatio - 0.004) * 100 / 0.008)
//     }
//   } else if (state.user.goal === 'MUSCLE GAIN') {
//     if(state.user.weight) {
//       let muscleGainRatio = state.user.goal_weight_delta / state.user.weight
//       if (muscleGainRatio < 0.002) {
//         muscleGainRatio = 0.002
//       } else if (muscleGainRatio > 0.005) {
//         muscleGainRatio = 0.005
//       }
//       oldSliderVal = Math.round((muscleGainRatio - 0.002) * 100 / 0.003)
//     }
//   } else { // 'MAINTENANCE'
//     targetWeight = state.user.target_weight
//     oldModifier = Math.round((state.user.use_metric_units === 1 ? state.user.goal_weight_delta : (state.user.goal_weight_delta * 2.204622)) * 10) / 10
//   }
//   return {
//     userId: state.user.id,
//     calorieBoost: state.user.calorie_restricted,
//     goal: state.user.goal,
//     oldSliderVal: oldSliderVal,
//     targetWeight: targetWeight,
//     oldModifier: oldModifier,
//     goal_weight_delta: state.user.goal_weight_delta,
//     goal_min_weekly_calorie_increase: state.user.goal_min_weekly_calorie_increase,
//     fullname: state.user.full_name,
//     vacationMode: state.user.vacation_mode,
//     lastWeighInDate: state.user.lastWeighInDate,
//     nearPeriod: state.user.near_period,
//     // redirectTo: state.dashboard.redirectTo,
//     // resumeGoalChangeMode: state.dashboard.resumeGoalChangeMode,
//     resumeGoalChangeMode: false,
//     useMetric: Number(state.user.use_metric_units),
//     weighins: state.user.weighins,
//     weight: state.user.weight,
//     isLoading: state.user.isLoading,
//     gender: state.user.gender
//   }
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ modifyUser, showModal, enableResumeGoalChangeMode, openFeedback }, dispatch)
// }


// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeGoalSettings))

export default withTheme(ChangeGoalSettings);
